var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitoredFires = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 41,
  fill: "none",
  viewBox: "0 0 32 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#MonitoredFires_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#767676",
  d: "M16 0C9.371 0 4 5.275 4 11.808c0 11.297 12 26.03 12 26.03s12-14.736 12-26.03C28 5.277 22.629 0 16 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.405 12.879a7.8 7.8 0 0 0-1.895-2.575l-.665-.597a.19.19 0 0 0-.168-.04.19.19 0 0 0-.129.114l-.297.833c-.185.523-.526 1.058-1.008 1.583a.14.14 0 0 1-.093.045.13.13 0 0 1-.099-.034.13.13 0 0 1-.045-.107c.084-1.346-.327-2.864-1.227-4.516-.745-1.372-1.78-2.443-3.074-3.19l-.944-.543c-.123-.071-.281.023-.274.164l.05 1.073c.034.733-.053 1.381-.258 1.92a6.3 6.3 0 0 1-1.074 1.822 6.7 6.7 0 0 1-1.086 1.03 7.9 7.9 0 0 0-2.292 2.716A7.6 7.6 0 0 0 8 16.027a7.55 7.55 0 0 0 .633 3.04c.406.927.992 1.769 1.725 2.479.74.715 1.6 1.278 2.557 1.67a8.2 8.2 0 0 0 3.129.612 8.2 8.2 0 0 0 3.128-.61 8 8 0 0 0 2.558-1.67 7.7 7.7 0 0 0 1.725-2.48c.42-.96.635-1.995.633-3.04a7.55 7.55 0 0 0-.683-3.15"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "MonitoredFires_svg__a",
  width: 32,
  height: 45.837,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5548_351"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5548_351",
  result: "shape"
})))));
export default SvgMonitoredFires;